import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import withReduxProvider from "web/react/redux-provider";
import { openEmailCaptureOverlay } from "web/redux/ducks/email-capture-overlay";
import PrimaryButton from "web/react/components/buttons/primary-button/primary-button";
import Button from "web/react/components/button/button";
import { gettext } from "web/script/modules/django-i18n";
import LeadLink from "web/react/components/lead-link/lead-link";
import environment from "web/script/modules/environment";
import userProfiler from "web/script/modules/userprofiler";

export function BuyOnStoreButton({
    leadUrl,
    leadLabel,
    openEmailCaptureOverlay,
    productId,
    reason,
    features,
}) {
    function onClickBuyNow() {
        if (!userProfiler.isLoggedIn() && environment.get("boomLeadSignupPrompt")) {
            openEmailCaptureOverlay({
                productId: productId,
                captureType: "signup_lead_save",
            });
        }
    }

    let button = null;
    let colourVariant =
        typeof features !== "undefined" && features != null
            ? features.pmt_208_colour_variant
            : null;
    switch (colourVariant) {
        case "tdwsnb":
        case "tdpsnb":
            button = (
                <Button styleType="tertiary" fullHeight fullWidth element="span">
                    {leadLabel}
                </Button>
            );
            break;
        default:
            button = (
                <PrimaryButton fullHeight fullWidth element="span">
                    {leadLabel}
                </PrimaryButton>
            );
            break;
    }

    return (
        <LeadLink
            afterOnClick={onClickBuyNow}
            href={leadUrl}
            openInNewTab={true}
            productId={productId}
            reason={reason}
        >
            {button}
        </LeadLink>
    );
}

BuyOnStoreButton.propTypes = {
    leadLabel: PropTypes.string,
    leadUrl: PropTypes.string.isRequired,
    openEmailCaptureOverlay: PropTypes.func,
    productId: PropTypes.string.isRequired,
    reason: PropTypes.string,
    features: PropTypes.object,
};

BuyOnStoreButton.defaultProps = {
    leadLabel: gettext("product.buy_area.shop_now"),
    reason: "buy-on-store-button",
};

export default withReduxProvider(
    connect(
        null,
        { openEmailCaptureOverlay }
    )(BuyOnStoreButton)
);
